<template>
  <div>
    <b-dropdown

      variant="link"
      toggle-class="btn btn-icon btn-hover-transparent-white d-flex align-items-center btn-lg px-md-2 w-md-auto"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <span style="font-size: 15px; color: white">
          {{
          languageFlag.name || getLanguageFlag
          }}
        </span>
        <img
          v-if="languageFlag"
          width="20"
          height="20"
          class="rounded-sm mr-2 ml-1"
          :src="languageFlag.lang == 'ru' ?
                require('@/assets/images/ru.svg') : require('@/assets/images/uz.svg')"
          alt
        />
      </template>
      <b-dropdown-text  tag="div" style="width: 220px; ">
        <KTDropdownLanguage class="p-2"  v-on:language-changed="onLanguageChanged"></KTDropdownLanguage>
      </b-dropdown-text>
    </b-dropdown>
  </div>
</template>

<script>
import i18nService from "@/core/services/i18n.service.js";
import KTDropdownLanguage from "@/views/dropdown/DropdownLanguage";
export default {
  components: {
    KTDropdownLanguage
  },
  data() {
    return {
      languageFlag: "",
      languages: i18nService.languages
    };
  },
  methods: {
    onLanguageChanged() {
      this.languageFlag = this.languages.find(val => {
        return val.lang === i18nService.getActiveLanguage();
      });
    }
  },
  computed: {
    getLanguageFlag() {
      return this.onLanguageChanged();
    }
  }
};
</script>

<style>
</style>
